import {
  doc,
  getDoc,
  onSnapshot,
  setDoc,
  deleteDoc,
  serverTimestamp,
} from "firebase/firestore";
import { useContext } from "react";
import { Events, TRACKING_CONTEXT } from "modules/tracking";
import logger from "logging/logger";
import { getLobbyDoc } from "../utils/lobbyFirestoreUtils";

const useLobbyGuestFirestore = () => {
  const { track } = useContext(TRACKING_CONTEXT);

  const isGuestApprovedIntoEvent = async (eventId: string, userId: string) => {
    const docRef = doc(getLobbyDoc(eventId), userId);
    const docSnap = await getDoc(docRef);
    const data = docSnap.data() || {};

    logger.info(
      `[isGuestApprovedIntoEvent] guest: ${userId} lobby state: ${data.state} for event: ${eventId}`,
    );

    return data.state === "APPROVED";
  };

  const listenForApproval = (
    userId: string,
    eventId: string,
    callback: () => void,
  ) =>
    onSnapshot(doc(getLobbyDoc(eventId), userId), (change) => {
      const data = change.data() || {};

      if (data.state === "APPROVED") {
        track(Events.REMOVED_FROM_LOBBY);
        callback();
      }
    });

  const addGuestInLobby = (
    userId: string,
    userName: string,
    eventId: string,
  ) => {
    logger.info(
      `[addGuestInLobby] guest: ${userId} entering lobby for event: ${eventId}`,
    );
    // Using current time always, user's latest time will be always taken for sorting
    setDoc(doc(getLobbyDoc(eventId), userId), {
      time: serverTimestamp(),
      state: "PENDING",
      name: userName,
    })
      .then(() => {
        track(Events.JOINED_LOBBY);

        return true;
      })
      .catch((error) => {
        logger.error(
          `[Lobby] adding document: error: ${error.message} userId: ${userId} event: ${eventId}`,
        );
      });
  };

  const removeGuestFromLobby = (userId: string, eventId: string) => {
    logger.info(
      `[Lobby] guest: ${userId} removing from lobby for event: ${eventId}`,
    );
    deleteDoc(doc(getLobbyDoc(eventId), userId))
      .then(() => {
        track(Events.REMOVED_FROM_LOBBY);

        return true;
      })
      .catch((error) => {
        logger.error(
          `[Lobby] removing document: error: ${error.message} userId: ${userId} event: ${eventId}`,
        );
      });
  };

  return {
    isGuestApprovedIntoEvent,
    removeGuestFromLobby,
    addGuestInLobby,
    listenForApproval,
  };
};

export default useLobbyGuestFirestore;
